<template>
  <svg
    class="text-blue-400"
    width="30px"
    height="23.5715968px"
    viewBox="0 0 30 23.5715968"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Extra-Large"
        fill="currentColor"
        fill-rule="nonzero"
      >
        <path
          d="M29.6863201,7.8138251 L22.1861906,0.313695614 C21.7676996,-0.104669817 21.0892997,-0.104544257 20.6709343,0.313946734 C20.4701013,0.514842498 20.3572858,0.78718182 20.357223,1.07126099 L20.357223,4.28559323 L12.8570935,4.28559323 C12.2653299,4.28559323 11.7856285,4.76529464 11.7856285,5.35705823 C11.7856285,5.94882182 12.2653299,6.42852324 12.8570935,6.42852324 L21.428688,6.42852324 C22.0204516,6.42852324 22.500153,5.94882182 22.500153,5.35705823 L22.500153,3.6576684 L27.4138123,8.57132769 L22.500153,13.484987 L22.500153,11.7856599 C22.500153,11.1938963 22.0204516,10.7141949 21.428688,10.7141949 L9.64276129,10.7141949 L9.64276129,7.49986268 C9.64263573,6.9080991 9.16280875,6.42852324 8.57110795,6.4286488 C8.28709156,6.42871158 8.01468946,6.54152711 7.81379369,6.74236009 L0.313726988,14.2424896 C-0.104575663,14.6609178 -0.104575663,15.3391293 0.313726988,15.7574948 L7.81385647,23.2576242 C8.01475224,23.4585828 8.28721712,23.5715918 8.57135907,23.5715918 C8.71217444,23.5720261 8.85173422,23.5443402 8.98168866,23.4901611 C9.38197348,23.324171 9.64288685,22.9334915 9.64276129,22.5001217 L9.64276129,19.2857894 L17.1428908,19.2857894 C17.7346544,19.2857894 18.2143558,18.806088 18.2143558,18.2143244 C18.2143558,17.6225608 17.7346544,17.1428594 17.1428908,17.1428594 L8.57135907,17.1428594 C7.97959548,17.1428594 7.49989406,17.6225608 7.49989406,18.2143244 L7.49989406,19.9136515 L2.58623477,15 L7.49989406,10.0863329 L7.49989406,11.7856599 C7.49989406,12.3774235 7.97959548,12.8571249 8.57135907,12.8571249 L20.357223,12.8571249 L20.357223,16.0714572 C20.3573486,16.6632208 20.8371756,17.1427966 21.4288764,17.1426711 C21.7128927,17.1426083 21.9852948,17.0297928 22.1861906,16.8289598 L29.6863201,9.32883028 C30.10456,8.91040207 30.10456,8.23219053 29.6863201,7.8138251 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
</template>
